import { makeStyles } from '@mui/styles';
import React, { useState, useEffect } from 'react';
import {
    Box,
    Button,
    Chip,
    Grid,
    Modal,
    Theme,
    Typography,
    IconButton,
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    InputAdornment
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { savecreateAchievement, getStudentProfile } from '../../../../../../Utils/apiService';
import KenLoader from '../../../../../../GlobalComponents/KenLoader';

const useStyles = makeStyles((theme: Theme) => ({
    clubsBox: {
        backgroundColor: '#FFFFFF !important',
        borderRadius: '12px !important',
        padding: '16px !important',
        border: '0.5px solid #BFCEFF',
        marginTop: '10px !important',
    },
    clubsTitle: {
        fontSize: '14px !important',
        textAlign: 'left',
        fontWeight: '500 !important',
        '@media (min-width: 1280px) and (max-width: 1300px)': {
            fontSize: '11px !important',
        },
    },
    clubsContent: {
        fontSize: '12px !important',
        textAlign: 'left',
        fontWeight: '400 !important',
        '@media (min-width: 1280px) and (max-width: 1300px)': {
            fontSize: '10px !important',
        },
    },
    extraCuricularBox: {
        backgroundColor: '#F6F8FB !important',
        borderRadius: '12px !important',
        padding: '10px !important',
        height: '49.3vh !important',
        '@media (min-width: 1440px) and (max-width: 1500px)': {
            height: '52vh !important',
        },
        '@media (min-width: 1920px) and (max-width: 1940px)': {
            height: '54vh !important',
        },
        '@media (min-width: 1280px) and (max-width: 1300px)': {
            padding: '10px !important',
            height: '43.8vh !important',
        },
    },
    categoriesTitle: {
        fontSize: '15px !important',
        textAlign: 'left',
        fontWeight: '500 !important',
        '@media (min-width: 1280px) and (max-width: 1300px)': {
            fontSize: '12px !important',
        },
    },
    categoryBtns: {
        width: '13%',
        height: '36px !important',
        borderRadius: '9px !important',
        padding: '9px !important',
        fontSize: '12px !important',
        fontWeight: '500 !important',
        '@media (min-width: 1280px) and (max-width: 1300px)': {
            fontSize: '10px !important',
            padding: '5px !important',
            height: '26px !important',
            width: '10%',
        },
    },
    certificateModal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    certificateContent: {
        backgroundColor: '#FFFFFF',
        borderRadius: '12px',
        padding: '24px',
        width: '80vw',
        height: '80vh',
        maxWidth: '1200px',
        position: 'relative',
        outline: 'none',
    },
    certificateHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '20px',
    },
    certificateTitle: {
        fontSize: '18px',
        fontWeight: '600',
        color: '#333333',
    },
    closeButton: {
        color: '#666666',
        cursor: 'pointer',
    },
    certificateIframe: {
        width: '100%',
        height: 'calc(100% - 60px)',
        border: 'none',
        borderRadius: '8px',
    },
    disabledChip: {
        opacity: 0.5,
        cursor: 'not-allowed',
    },
    // Add Achievement Modal Styles
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    modalContent: {
        backgroundColor: '#FFFFFF',
        borderRadius: '12px',
        padding: '24px',
        width: '400px',
        maxWidth: '90vw',
        position: 'relative',
        outline: 'none',
    },
    modalHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '20px',
    },
    modalTitle: {
        fontSize: '18px',
        fontWeight: '600',
        color: '#333333',
    },
    formField: {
        marginBottom: '16px !important',
        '& .MuiOutlinedInput-root': {
            borderRadius: '8px',
        },
        '& .MuiSelect-select': {
            borderRadius: '8px',
        },
        '& .MuiPopover-root': {
            zIndex: 9999,
        },
    },
    dateField: {
        marginBottom: '16px !important',
        '& .MuiOutlinedInput-root': {
            borderRadius: '8px',
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: '#3061FF',
            },
        },
        '& .MuiInputLabel-root': {
            '&.Mui-focused': {
                color: '#3061FF',
            },
        },
    },
    modalActions: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: '24px',
        gap: '12px',
    },
    cancelButton: {
        backgroundColor: '#EAEFFF !important',
        color: '#2C58E8 !important',
        borderRadius: '8px',
        textTransform: 'none',
        flex: 1,
        '&:hover': {
            backgroundColor: '#E0E0E0',
        },
    },
    submitButton: {
        backgroundColor: '#3061FF',
        color: '#FFFFFF',
        borderRadius: '8px',
        textTransform: 'none',
        flex: 1,
        '&:hover': {
            backgroundColor: '#1E4BD8',
        },
    },
    fileUploadField: {
        '& .MuiOutlinedInput-root': {
            cursor: 'pointer',
        },
    },
}))

const Achievements = (props: any) => {
    const classes = useStyles();
    const [openAchieve, setOpenAchieve] = useState(false);
    const [certificateModal, setCertificateModal] = useState(false);
    const [selectedCertificate, setSelectedCertificate] = useState<string>('');
    const [localData, setLocalData] = useState(props?.props?.data);
    const [isLoading, setIsLoading] = useState(false);
    const [formData, setFormData] = useState({
        title: '',
        achievedDate: null,
        position: '1st place',
        certificate: null as string | null,
        description: ''
    });

    // Update local data when props change
    useEffect(() => {
        setLocalData(props?.props?.data);
    }, [props?.props?.data]);

    const handleCloseAchieve = () => {
        setOpenAchieve(false);
        setFormData({
            title: '',
            achievedDate: null,
            position: '1st place',
            certificate: null,
            description: ''
        });
    };
    const handleOpenAchieve = () => setOpenAchieve(true);

    // Extract achievements data and filter by RecordType.Name === "Achievement"
    const achievementsData = localData?.achievements || [];
    const filteredAchievements = achievementsData.filter((achievement: any) =>
        achievement.RecordType?.Name === "Achievement"
    );

    // Helper function to format date
    const formatAchievementDate = (dateString: string) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        const day = date.getDate();
        const month = date.toLocaleDateString('en-US', { month: 'short' });
        const year = date.getFullYear();

        // Add ordinal suffix to day
        const getOrdinalSuffix = (day: number) => {
            if (day > 3 && day < 21) return 'th';
            switch (day % 10) {
                case 1: return 'st';
                case 2: return 'nd';
                case 3: return 'rd';
                default: return 'th';
            }
        };

        return `Achieved on ${day}${getOrdinalSuffix(day)} ${month} ${year}`;
    };

    const handleInputChange = (field: string, value: any) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleFileUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            try {
                const base64 = await convertFileToBase64(file);
                setFormData(prev => ({
                    ...prev,
                    certificate: base64
                }));
            } catch (error) {
                console.error('Error converting file to base64:', error);
            }
        }
    };

    const convertFileToBase64 = (file: File): Promise<string> => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                const base64String = reader.result as string;
                // Remove the data URL prefix to get just the base64 string
                const base64 = base64String.split(',')[1];
                resolve(base64);
            };
            reader.onerror = error => reject(error);
        });
    };

    const handleSubmit = async () => {
        setIsLoading(true);
        try {
            const contactId = localData?.studentDetails[0]?.Id;
            if (!contactId) {
                console.error('Contact ID not available');
                return;
            }
            const payload = {
                Name: formData.title,
                StartDate: formData.achievedDate ? dayjs(formData.achievedDate).format('YYYY-MM-DD') : '',
                Description: formData.description,
                Place: formData.position,
                fileName: formData.certificate ? 'achievement_certificate.pdf' : '',
                base64File: formData.certificate || ''
            };

            const response = await savecreateAchievement(contactId, payload);
            if (response) {
                handleCloseAchieve();
                const updatedData = await getStudentProfile(contactId);
                if (updatedData?.data) {
                    console.log('Updated student profile data:', updatedData.data);
                    // Update local data
                    setLocalData(updatedData.data);
                    // Call the callback function to update parent component's state
                    if (props?.props?.onDataUpdate) {
                        props.props.onDataUpdate(updatedData.data);
                        setIsLoading(false);
                    }
                }
                setIsLoading(false);
            } else {
                console.error('Failed to create achievement');
            }
        } catch (error) {
            console.error('Error creating achievement:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleViewCertificate = (certificateUrl: string) => {
        if (certificateUrl) {
            setSelectedCertificate(certificateUrl);
            setCertificateModal(true);
        }
    };

    const handleCloseCertificate = () => {
        setCertificateModal(false);
        setSelectedCertificate('');
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            {isLoading && <KenLoader />}
            <Box className={`${classes.extraCuricularBox} scrollbar-cusgray`}>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <Typography className={classes.categoriesTitle}>Achievements</Typography>
                    </Grid>
                    <Grid item xs={6} display={'flex'} justifyContent={'end'}>
                        <Button size="small" variant="contained" className={classes.categoryBtns} onClick={handleOpenAchieve}>
                            + Add
                        </Button>
                    </Grid>
                </Grid>

                {filteredAchievements.length > 0 ? (
                    filteredAchievements.map((achievement: any, index: number) => (
                        <Box key={achievement.Id} className={classes.clubsBox}>
                            <Grid container spacing={2} display={'flex'} justifyContent={'space-between'}>
                                <Grid item>
                                    <Typography className={classes.clubsTitle}>
                                        {achievement.Organisation_Name__c || 'Achievement Title Not Available'}
                                    </Typography>
                                    <Typography marginTop={2} textAlign={'left'} fontSize={'14px'} fontWeight={'500'} mt={0.3}>
                                        {formatAchievementDate(achievement.Start_Date__c)}
                                    </Typography>
                                    <Typography marginTop={2} className={classes.clubsContent}>
                                        {achievement.Description__c || 'No description available'}
                                    </Typography>
                                </Grid>
                                <Grid item>
                                    <Box display={'flex'} justifyContent={'end'}>
                                        <Chip
                                            label={achievement.Winning_Place__c || 'Place Not Available'}
                                            sx={{
                                                backgroundColor: '#C1DCC3',
                                                fontSize: '12px',
                                                fontWeight: 500,
                                                '@media (min-width: 1280px) and (max-width: 1300px)': {
                                                    fontSize: '10px !important',
                                                },
                                            }}
                                        />
                                    </Box>
                                    <Chip
                                        size='small'
                                        label="View certificate"
                                        className={`mt-4 ${!achievement?.Certification__c ? classes.disabledChip : ''}`}
                                        onClick={() => handleViewCertificate(achievement?.Certification__c)}
                                        sx={{
                                            cursor: achievement.Certification__c ? 'pointer' : 'not-allowed',
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                    ))
                ) : (
                    <Box className={classes.clubsBox}>
                        <Grid container spacing={2} display={'flex'} justifyContent={'space-between'}>
                            <Grid item>
                                <Typography className={classes.clubsContent}>
                                    No achievements data available
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>
                )}

                {/* Add Achievement Modal */}
                <Modal
                    open={openAchieve}
                    onClose={handleCloseAchieve}
                    className={classes.modal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box className={classes.modalContent}>
                        <Box className={classes.modalHeader}>
                            <Typography className={classes.modalTitle}>
                                Add Achievement
                            </Typography>
                            <IconButton onClick={handleCloseAchieve} className={classes.closeButton}>
                                <CloseIcon />
                            </IconButton>
                        </Box>

                        <TextField
                            fullWidth
                            label="Title of the achievement"
                            variant="outlined"
                            className={classes.formField}
                            value={formData.title}
                            onChange={(e) => handleInputChange('title', e.target.value)}
                            placeholder="Add title"
                        />

                        <DatePicker
                            label="Achieved on"
                            value={formData.achievedDate}
                            onChange={(newValue) => handleInputChange('achievedDate', newValue)}
                            className={classes.dateField}
                            slotProps={{
                                textField: {
                                    fullWidth: true,
                                    variant: 'outlined',
                                    className: classes.dateField,
                                    placeholder: "Choose dates"
                                },
                            }}
                        />

                        <FormControl fullWidth className={classes.formField}>
                            <InputLabel>Position</InputLabel>
                            <Select
                                value={formData.position}
                                label="Position"
                                onChange={(e) => handleInputChange('position', e.target.value)}
                                MenuProps={{
                                    PaperProps: {
                                        style: {
                                            maxHeight: "35%",
                                            zIndex: 9999,
                                        },
                                    },
                                }}
                            >
                                <MenuItem value="1st place">1st place</MenuItem>
                                <MenuItem value="2nd place">2nd place</MenuItem>
                                <MenuItem value="3rd place">3rd place</MenuItem>
                            </Select>
                        </FormControl>

                        <TextField
                            fullWidth
                            label="Upload certificate"
                            variant="outlined"
                            className={`${classes.formField} ${classes.fileUploadField}`}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <CloudUploadIcon />
                                    </InputAdornment>
                                ),
                                readOnly: true,
                            }}
                            onClick={() => document.getElementById('certificate-upload')?.click()}
                            placeholder="Upload certificate"
                        />
                        <input
                            id="certificate-upload"
                            type="file"
                            style={{ display: 'none' }}
                            onChange={handleFileUpload}
                            accept=".pdf,.jpg,.jpeg,.png"
                        />

                        <TextField
                            fullWidth
                            label="Enter description"
                            variant="outlined"
                            multiline
                            rows={3}
                            className={classes.formField}
                            value={formData.description}
                            onChange={(e) => handleInputChange('description', e.target.value)}
                            placeholder="Description"
                        />

                        <Box className={classes.modalActions}>
                            <Button
                                className={classes.cancelButton}
                                onClick={handleCloseAchieve}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                className={classes.submitButton}
                                onClick={handleSubmit}
                            >
                                Submit
                            </Button>
                        </Box>
                    </Box>
                </Modal>

                {/* Certificate Modal */}
                <Modal
                    open={certificateModal}
                    onClose={handleCloseCertificate}
                    className={classes.certificateModal}
                    aria-labelledby="certificate-modal-title"
                    aria-describedby="certificate-modal-description"
                >
                    
                    <Box className={classes.certificateContent}>
                        <Box className={classes.certificateHeader}>
                            <Typography className={classes.certificateTitle}>
                                Certificate
                            </Typography>
                            <IconButton onClick={handleCloseCertificate} className={classes.closeButton}>
                                <CloseIcon />
                            </IconButton>
                        </Box>
                        <iframe
                            src={selectedCertificate}
                            className={classes.certificateIframe}
                            title="Certificate"
                        />
                    </Box>
                </Modal>
            </Box>
        </LocalizationProvider>
    )
}

export default Achievements